import React, { useRef } from 'react';

import { Box, Loader, Transition } from '@mantine/core';
import { IconCircleCheck, IconCircleDashed } from '@tabler/icons-react';

import PopIn from './PopIn';

export type SaveStatus = 'idle' | 'dirty' | 'saving' | 'saved';

const SaveStatusIndicator = ({ status }: { status: SaveStatus }): JSX.Element => {
  // Keep the last non-idle status so the icon doesn't change during the exit fade.
  const lastVisible = useRef<SaveStatus>('dirty');
  if (status !== 'idle') lastVisible.current = status;

  return (
    <Transition
      mounted={status !== 'idle'}
      transition='fade'
      duration={250}
      exitDuration={600}
      timingFunction='ease'
    >
      {styles => (
        <Box style={{ ...styles, display: 'flex', alignItems: 'center' }}>
          <PopIn key={lastVisible.current}>
            {lastVisible.current === 'saving' && <Loader size='xs' />}
            {lastVisible.current === 'saved' && <IconCircleCheck size={16} color='green' />}
            {lastVisible.current === 'dirty' && <IconCircleDashed size={16} color='gray' />}
          </PopIn>
        </Box>
      )}
    </Transition>
  );
};

export default SaveStatusIndicator;
